import { Link } from 'react-router-dom';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { breakpoint } from '~/styles/themes';

export const Container = styled.div`
  position: fixed;
  width: 100%;
  max-width: ${breakpoint.mobile_large};
  height: 100%;
`;

export const Background = styled.div`
  display: block;
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.8) 60%
    );
  }
`;

export const LoginWrapper = styled.div`
  display: flex;
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  margin-bottom: 30px;
  padding: 0 16px;
  gap: 16px;
`;

export const Logo = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 3px;
    margin-bottom: 8%;

    & > img {
      display: block;
      max-width: 40%;
      text-align: center;
    }

    & > p {
      display: block;
      text-align: center;
      ${theme.fontStyle.poppins.desc2}
    }
  `}
`;

export const EmailLogin = styled(Link)`
  ${({ theme }) => css`
    display: block;

    span {
      color: ${theme.content.content_light_1};
      ${theme.fontStyle.text.body18_medium}
      text-decoration: underline;
      text-underline-position: under;
    }
  `}
`;
